import { ServiceUtil as serviceUtil } from './services.util'

export const LoanInfoApi = {
    getUserLoanViews,
    getUserLoanActivity,
    startPayment,
    startGuestPayment,
    getPaymentUrl,
    getPaymentProcessor,
    setPaymentSession,
    getSavedPayments,
    deleteSavedPayments,
    getInstantFundingUrl,
    isValidLoginHash,
    getACHAuthorization,
    // getBannerData
}

function getUserLoanViews() {
    return serviceUtil.executeServiceCall("LoanInfoAPI",
        "LoanInfo/LoanAccountViews", serviceUtil.getRequest())
        .then(response => {
            if (response.data && response.data.length > 0) {
                const loan = response.data[0];
                serviceUtil.setLocalBranchId(loan.sunLoanBranchId);
            }
            return response;
        });
}

function getACHAuthorization(loanId) {
    return serviceUtil.executeServiceCall(
        "LoanInfoAPI",
        "LoanInfo/GetACHAuthorization",
        serviceUtil.postRequest(loanId)
    );
}

function getUserLoanActivity(currentLoanId) {
    return serviceUtil.executeServiceCall("LoanInfoAPI",
        "LoanInfo/AccountActivity", serviceUtil.postRequest(currentLoanId));
}

function startPayment() {
    return serviceUtil.executeServiceCall("LoanInfoAPI",
        "Payment/StartPayment/", serviceUtil.getRequest());
}

function startGuestPayment(userHash) {
    return serviceUtil.executeServiceCall("LoanInfoAPI",
        "Payment/StartPayment/", serviceUtil.postRequest(userHash));
}

// Obsoleted by getPaymentProcessor
function getPaymentUrl(currentLoanId, paymentAmount, paymentType, storedPmtId, userHash) {
    let paymentRequest = {
        currentLoanId: currentLoanId,
        PaymentAmount: paymentAmount,
        PaymentType: paymentType,
        userHash: userHash
    }

    if (storedPmtId) {
        paymentRequest.StoredPmtId = storedPmtId;
    }
    return serviceUtil.executeServiceCall("LoanInfoAPI",
        "Payment/MakePayment", serviceUtil.postRequest(paymentRequest));
}

function getPaymentProcessor(currentLoanId, paymentAmount, userHash, processorRequest) {
    let paymentRequest = {
        currentLoanId: currentLoanId,
        paymentAmount: paymentAmount,
        processorData: processorRequest,
        userHash: userHash
    }

    return serviceUtil.executeServiceCall("LoanInfoAPI",
        "Payment/MakePayment", serviceUtil.postRequest(paymentRequest));
}

function setPaymentSession(paymentSessionId, success) {
    let sessionUpdate = { SessionId: paymentSessionId, Succeeded: success }
    return serviceUtil.executeServiceCall("LoanInfoAPI",
        "Payment/UpdatePaymentSession", serviceUtil.postRequest(sessionUpdate));
}

function getSavedPayments(processor) {
    return serviceUtil.executeServiceCall("LoanInfoAPI", "Payment/SavedPaymentMethods/" + processor, serviceUtil.getRequest());
}

function deleteSavedPayments(storedPaymentIds) {
    return serviceUtil.executeServiceCall("LoanInfoAPI", "Payment/DeletePayments", serviceUtil.postRequest(storedPaymentIds));
}

function getInstantFundingUrl(instantFundingRequest){
    return serviceUtil.executeServiceCall("LoanInfoAPI", "InstantFunding/GetInstantFundingUrl",serviceUtil.postRequest(instantFundingRequest))
}
function isValidLoginHash(request) {
    return serviceUtil.executeServiceCall("LoanInfoAPI",
    "TouchlessRefi/IsValidToken", serviceUtil.postRequest(request))
}




// WEBPACK FOOTER //
// ./src/_services/loaninfo.service.js